// extracted by mini-css-extract-plugin
export default {"filter-item":"Categories_filter-item__vXu8X"};